

import * as THREE from 'three'
import Experience from "../Experience";
import Soul from './assets/Soul';
import EventEmitter from '../Utils/EventEmitter.js';
import Lava from './assets/Lava.js';
import Blob from './assets/Blob.js';
import anim from '../Utils/Anim.js'
import vertex from '../../shaders/plane/vertex.glsl'
import fragment from '../../shaders/plane/fragment.glsl'
import vertexLoader from '../../shaders/loader/vertex.glsl'
import fragmentLoader from '../../shaders/loader/fragment.glsl'
import GreyIdea from './assets/GreyIdea.js';
import MachineFireworks from './assets/machineFireworks.js';

export default class Tableau1 extends EventEmitter {
    constructor(_options) {
        super()
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.model = _options.model
        this.modelTexture = _options.modelTexture
        // 
        this.isDestroyed = false
        // renderer setup
        anim.to(this.experience.renderer.darkMaterial, { opacity: 1, duration: 1, })
        // 
        // ? secondary meshes
        this.lava = new Lava({
            position: new THREE.Vector3(0, 1.21, -0.5),
            noise: this.ressources.items.noise.clone()
        })
        this.blob = null
        this.greyIdea = null
        this.fireworks = new MachineFireworks()
        // 
        this.setModel()
        this.setEmissiveMaterial()
        this.setSouls()
        this.eventGesture()



    }

    eventGesture() {
        this.on('goTo', () => {
            this.loaderAnim()
            const otherSouls = this.souls.filter(soul => !soul.isAnimating)
            // console.log(otherSouls);

            otherSouls.forEach((soul, i) => {
                setTimeout(() => {
                    if (soul.position) {
                        anim.to(soul.position, {
                            x: -1.5 - i * 0.3,
                            y: soul.mesh.position.y,
                            z: 1,
                            duration: 1,
                            easing: 'power1.inout',
                        })
                    }

                }, i * 100)
            })
        })
        this.on('ideaGot', () => {
            const remapedSouls = this.souls.filter(soul => !soul.isAnimating);
            remapedSouls[0].getIdea()

        })
        this.on('soulLeft', () => {

            const soul = this.souls.shift();
            soul.position.x = -6;
            this.souls.push(soul);



        })

        // 
        this.on('drop', () => {
            this.animTrapes()
            this.greyIdea?.live()

        })
        this.on('press', () => {
            this.animPistons()
        })
    }

    setModel() {

        this.modelTexture.colorSpace = THREE.SRGBColorSpace
        this.modelTexture.flipY = false
        this.machineMaterial = new THREE.MeshBasicMaterial({ map: this.modelTexture, side: THREE.DoubleSide })
        this.scene.add(this.model.scene)
        // console.log(this.model.scene);
        this.morpionPlanes = []

        this.model.scene.traverse((child) => {
            if (child.isMesh) {
                child.material = this.machineMaterial



            }
            if (child.isMesh && child.name.includes('morpionPlane')) {
                this.morpionPlanes.push(child)
            }
        })

        this.trapeL = this.model.scene.children.find((child) => child.name === 'trapeL')
        this.trapeR = this.model.scene.children.find((child) => child.name === 'trapeR')
        this.vitrine = this.model.scene.children.find((child) => child.name === "vitrine")
        this.doorL = this.model.scene.children.find((child) => child.name === "porteL")
        this.doorR = this.model.scene.children.find((child) => child.name === "porteR")
        this.pistonL = this.model.scene.children.find((child) => child.name === "pistonL").children.find((child) => child.name === "smallCylinder")
        this.pistonR = this.model.scene.children.find((child) => child.name === "pistonR").children.find((child) => child.name === "smallCylinder001")
        this.loader = this.model.scene.children.find((child) => child.name === "Empty").children.find((child) => child.name === "loader")
        this.neonR = this.model.scene.children.find((child) => child.name === 'neonR')
        this.neonL = this.model.scene.children.find((child) => child.name === 'neonL')
        // init positions
        this.pistonL.position.x = 7.83 - 1.4
        this.pistonR.position.x = 7.83 - 1.4
        // this.pistonR.position.x = 7.83 + 1.4







        // 
        // recreate transparent material here for the vitrine
        // this.vitrine.visible = false
        // this.doorR.visible = false
        // this.doorL.visible = false
        // 
        this.vitrine.layers.enable(1)
        this.doorL.layers.enable(1)
        this.doorR.layers.enable(1)

        this.vitrine.material = new THREE.MeshBasicMaterial({
            transparent: true,
            color: '#000000',
            opacity: 0.1,
            side: THREE.DoubleSide,
            depthWrite: false,
            depthTest: false,


        })
        const doorsMaterial = new THREE.MeshBasicMaterial({
            transparent: true,
            color: 'black',
            opacity: 0.4,
            side: THREE.DoubleSide,
            depthWrite: false,
            depthTest: false,

        })
        this.doorR.children.find((child) => child.isMesh ? child.material = doorsMaterial : null)
        this.doorL.children.find((child) => child.isMesh ? child.material = doorsMaterial : null)
    }
    animTrapes() {
        anim.to(this.trapeL.rotation, {
            z: -Math.PI * 0.45,
            duration: 0.5,
            easing: 'power1.out',
            onComplete: () => {
                setTimeout(() => {
                    if (!this.isDestroyed) {
                        this.blob = new Blob({
                            position: new THREE.Vector3(0, 0.7, -0.5),
                            noise: this.ressources.items.noise
                        })
                        this.blob.live()
                        anim.to(this.trapeL.rotation, {
                            z: 0,
                            duration: 0.5,
                            easing: 'power1.out',
                        })
                    }
                }, 500)

            }
        })
        anim.to(this.trapeR.rotation, {
            z: Math.PI * 0.45,
            duration: 0.5,
            easing: 'power1.out',
            onComplete: () => {

                setTimeout(() => {
                    anim.to(this.trapeR.rotation, {
                        z: 0,
                        duration: 0.5,
                        easing: 'power1.out',
                    })
                }, 500)
            }
        })

    }
    animPistons() {
        this.pistonClosed = false
        this.pistonL.position.x = 7.83 - 1.4
        anim.to(this.pistonL.position, {
            x: 7.83,
            duration: 0.5,
            easing: 'power4.in',
            onComplete: () => {
                this.pistonL.position.x = 7.83
                this.pistonClosed = true

                setTimeout(() => {
                    this.pistonClosed = false

                    if (this.blob) {
                        this.blob?.destroy()

                    }

                    this.isDestroyed ? null : this.greyIdea = new GreyIdea()

                    anim.to(this.pistonL.position, {
                        x: 7.83 - 1.4,
                        duration: 1,
                        easing: 'power4.inout',
                    })
                }, 1000)
            }
        })
        // 
        this.pistonR.position.x = 7.83 - 1.4
        anim.to(this.pistonR.position, {
            x: 7.83,
            duration: 0.5,
            easing: 'power4.in',
            onComplete: () => {
                this.pistonR.position.x = 7.83

                setTimeout(() => {
                    anim.to(this.pistonR.position, {
                        x: 7.83 - 1.4,
                        duration: 1,
                        easing: 'power4.inout',
                    })
                }, 1000)
            }
        })


    }

    setEmissiveMaterial() {
        // ! emissiveIntensity DOIT rester entre 0 et 1 sinon on créer de l'aliasing sur la mesh
        // ! on jouera sur la couleur d'émission pour changer la puissance de l'éclairage
        this.glowMaterial = new THREE.MeshStandardMaterial({
            // emissive: '#ffffff',
            emissive: '#FFB4AB',
            emissiveIntensity: 0.4
        });
        // ambien light nécessaire pour créer le glow du bloom sur ce materiaux
        // il faudra créer une class de material glowy qui permettra de le régler pour chaque instance

        const material = new THREE.ShaderMaterial({
            vertexShader: vertex,
            fragmentShader: fragment,
            uniforms: {
                u_power: new THREE.Uniform(1)
            }
        })
        this.morpionPlanes.forEach((plane, i) => {
            plane.material = material.clone()
            // plane.material = material
            // 1 layer is for the bloom
            plane.layers.enable(1)

        })

        setInterval(() => {
            this.morpionPlanes.forEach((plane) => {
                plane.material.uniforms.u_power.value = Math.floor(Math.random() * 5 + 1)
            })
        }, 500)
        this.loader.material = new THREE.ShaderMaterial({
            vertexShader: vertexLoader,
            fragmentShader: fragmentLoader,
            uniforms: {
                u_power: new THREE.Uniform(1),
                u_LoaderProgress: new THREE.Uniform(0)
            }
        })
        this.loader.layers.enable(1)
        // 



    }

    loaderAnim() {
        this.loader.material.uniforms.u_LoaderProgress.value = 0
        anim.to(this.loader.material.uniforms.u_LoaderProgress, {
            value: 1,
            duration: 3.5,
        })
    }
    setSouls() {
        this.souls = []
        if (this.experience.debug.active) {
            this.soulsFolder = this.experience.debug.ui.addFolder('Souls').close()
            // this.soulsFolder.close()
        }
        for (let i = 0; i < 20; i++) {
            const soul = new Soul({
                position: new THREE.Vector3(-1.5 - i * 0.3, 0.09, 1),
                debugFolder: this.soulsFolder,
                index: i,
                isRandom: true,

            })
            this.souls.push(soul)
        }

        this.souls[0].getIdea()
        // 
        // this.test = new Soul({
        //     position: new THREE.Vector3(0, 0, -1),
        //     debugFolder: this.soulsFolder,
        //     isRandom: false,
        // })
        // this.test.mesh.scale.set(1, 1, 1)
        // anim.to(this.test.position, {

        //     z: 0,
        //     duration: 1,
        //     easing: 'power1.inout',
        // })


    }
    // 
    destroy() {
        const blackScreen = document.querySelector('.blackScreen');

        // 1. S'assurer que le blackScreen est caché au début
        blackScreen.style.transition = 'none'; // Pas de transition initiale
        blackScreen.style.opacity = '0';

        // 2. On applique immédiatement la visibilité du blackScreen avec une transition douce
        setTimeout(() => {
            blackScreen.style.transition = 'opacity 0.3s ease-in-out'; // Transition pour l'opacité
            blackScreen.style.opacity = '1'; // Rendre le blackScreen visible (en douceur)
        }, 10); // Attendre une petite fraction de temps pour déclencher la transition

        // 3. Appliquer la destruction des objets après que le blackScreen soit visible
        setTimeout(() => {
            // Marquer l'objet comme détruit
            this.isDestroyed = true;

            // Nettoyer les événements
            this.off('goTo');
            this.off('ideaGot');
            this.off('soulLeft');
            this.off('drop');
            this.off('press');

            // Supprimer le modèle de la scène
            if (this.model && this.model.scene) {
                this.scene.remove(this.model.scene);
            }

            // Nettoyer les objets secondaires
            if (this.lava) {
                this.lava.destroy();
            }

            if (this.blob) {
                this.blob.destroy();
            }

            if (this.greyIdea) {
                this.greyIdea.destroy();
            }

            // Nettoyer les materials et textures si nécessaire
            if (this.modelTexture) {
                this.modelTexture.dispose();
            }
            if (this.model?.scene) {
                this.model.scene.traverse((child) => {
                    if (child.isMesh) {
                        if (child.geometry) child.geometry.dispose();
                        if (child.material) {
                            if (Array.isArray(child.material)) {
                                child.material.forEach((m) => m.dispose());
                            } else {
                                child.material.dispose();
                            }
                        }
                    }
                });
            }

            // Supprimer les matériaux des objets de la scène pour libérer la mémoire
            if (this.morpionPlanes && this.morpionPlanes.length) {
                this.morpionPlanes.forEach((plane) => {
                    if (plane.material) {
                        plane.material.dispose();
                    }
                });
            }

            // Nettoyer les âmes
            if (this.souls && this.souls.length) {
                this.souls.forEach((soul) => {
                    soul.destroy();
                });
                this.souls = [];
            }

            // Si le loader a un matériau, on le dispose
            if (this.loader && this.loader.material) {
                this.loader.material.dispose();
            }

            // Réinitialiser ou libérer la mémoire des shaders
            if (this.loader.material && this.loader.material.uniforms) {
                this.loader.material.uniforms.u_LoaderProgress.value = 0;
            }

            // Revenir à l'état initial (par exemple réinitialiser certaines positions ou états si nécessaire)

            // 4. À la fin de la destruction, lancer la disparition du blackScreen
            setTimeout(() => {
                blackScreen.style.opacity = '0'; // Transition vers la disparition du blackScreen
            }, 500); // Temps d'attente avant de commencer à faire disparaître le blackScreen (après la destruction)
        }, 1000); // Attente d'1 seconde avant de commencer la destruction (temps d'affichage du blackScreen)

    }


    // 



    updateDoors() {
        let openLeft = false;
        let openRight = false;

        this.souls.forEach((soul) => {
            const distancedoorL = soul.position.distanceTo(this.doorL.position)
            const distancedoorR = soul.position.distanceTo(this.doorR.position)

            if (distancedoorL < 0.5) openLeft = true
            if (distancedoorR < 0.5) openRight = true
        })

        const openEuler = new THREE.Euler(0, Math.PI * 0.5, 0);
        const closedEuler = new THREE.Euler(0, 0, 0);
        const openQuat = new THREE.Quaternion().setFromEuler(openEuler);
        const closedQuat = new THREE.Quaternion().setFromEuler(closedEuler);

        this.doorL.quaternion.slerp(openLeft ? openQuat : closedQuat, 0.1);
        this.doorR.quaternion.slerp(openRight ? openQuat : closedQuat, 0.1);
    }
    updateSouls() {
        // logic d'update des souls

    }


    update() {
        if (this.souls?.length) {
            this.souls.forEach((soul, i) => {
                soul.update()
            })
            // 

            this.updateDoors()

        }
        this.lava?.update()
        this.test?.update()

        if (this.pistonClosed && !this.isDestroyed) {
            this.fireworks.createFire(
                500,                       //count
                new THREE.Vector3(0, 0.45, -0.5),       // position
                0.01,                       // size
                0.35,                         // radius
                new THREE.Color('#AF8D87').multiplyScalar(0.1) // Color
            )
        }


    }
}